import { render, staticRenderFns } from "./daochuConfigModal.vue?vue&type=template&id=4b380160&scoped=true"
import script from "./daochuConfigModal.vue?vue&type=script&lang=js"
export * from "./daochuConfigModal.vue?vue&type=script&lang=js"
import style0 from "./daochuConfigModal.vue?vue&type=style&index=0&id=4b380160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b380160",
  null
  
)

export default component.exports